export default __webpack_public_path__ + "static/media/Motivation1.7da28e5e.png";